import { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

// Scroll-driven cinematic reveal envelope: sections scale/fade/parallax in and
// cross-dissolve out as you move — the "sections breathe" feel.
export default function SectionReveal({ children, className = "" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const p = useSpring(scrollYProgress, { stiffness: 110, damping: 30, mass: 0.4 });

  const opacity = useTransform(p, [0, 0.16, 0.82, 1], [0.1, 1, 1, 0.45]);
  const scale = useTransform(p, [0, 0.16, 0.9, 1], [0.955, 1, 1, 0.985]);
  const y = useTransform(p, [0, 0.16], [70, 0]);

  return (
    <motion.div
      ref={ref}
      style={{ opacity, scale, y }}
      className={`will-change-transform ${className}`}
    >
      {children}
    </motion.div>
  );
}
